import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ModalCard from '../ui/ModalCard';
import StatusIconCircle from '../ui/StatusIconCircle';
import { CheckIcon } from '../icons';

export default function RegisterSuccessCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ModalCard title={t('register.success.cardTitle')}>
      <StatusIconCircle icon={<CheckIcon size={28} />} variant="accent" />

      <Typography variant="h3" component="h1">
        {t('register.success.headline')}
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {t('register.success.description')}
      </Typography>

      <Button
        type="button"
        variant="contained"
        fullWidth
        onClick={() => navigate('/login')}
        sx={(theme) => ({
          backgroundColor: theme.app.primary,
          color: theme.app.primaryForeground,
          '&:hover': { backgroundColor: theme.app.primaryHover },
        })}
      >
        {t('register.success.backToLogin')}
      </Button>
    </ModalCard>
  );
}
